export default __webpack_public_path__ + "static/media/verlinde-banner-tablet.e3f39466.png";